export default __webpack_public_path__ + "static/media/muktopaath.d296a5ab.png";